import graphql__45a10d722714d4d8a2b4 from "./__generated__/ContributionsMapContributionsList_participativeModule.graphql.js";import { useCallback, useContext } from "react";
import { graphql, useFragment } from "react-relay";

import useFilterableContributionsList from "../useFilterableContributionsList";
import InfinitelyScrollableContainer from "../../../Utils/InfinitelyScrollableContainer";
import { BoxSpinner } from "../../../Utils/Spinner";
import ContributionCard from "../ContributionCard";
import { ContributionsMapContributionsFragment_participativeModule } from "./ContributionsMapContributionsFragment";
import { useNavigateTo } from "../../../Routes/RoutesContext";
import { MapPanelSizingContext } from "../../../Maps/MapPanel/withMapPanelSizing";

export const CONTRIBUTIONS_BATCH_SIZE = 10;

const ContributionsMapContributionsList = props => {
  const participativeModule = useFragment(
    ContributionsMapContributionsList_participativeModule,
    props.participativeModule
  );
  const { slug: participativeModuleSlug } = participativeModule;

  const { contributions, loadMore, isLoadingNext } = useFilterableContributionsList({
    contribuable: props.participativeModule,
    fragment: ContributionsMapContributionsFragment_participativeModule,
    contributionsBatchSize: CONTRIBUTIONS_BATCH_SIZE
  });

  const navigateTo = useNavigateTo();
  const handleClick = useCallback(
    contributionSlug =>
      navigateTo("contribution", { participativeModuleSlug, contributionSlug }),
    [navigateTo, participativeModuleSlug]
  );

  const { innerPanel } = useContext(MapPanelSizingContext);

  if (!innerPanel) return null;

  return (
    <InfinitelyScrollableContainer
      className="boxes-list"
      onBottomReached={loadMore}
      scrollableContainer={innerPanel}
      offset={300}
    >
      <ul className="padding-none">
        {contributions.map(contribution => (
          <ContributionCard
            key={contribution.id}
            contribution={contribution}
            showUnlocatedIndicator={true}
            onClick={() => handleClick(contribution.slug)}
          />
        ))}
      </ul>
      {isLoadingNext && <BoxSpinner />}
    </InfinitelyScrollableContainer>
  );
};

const ContributionsMapContributionsList_participativeModule = graphql__45a10d722714d4d8a2b4;

export default ContributionsMapContributionsList;
